import React, { useEffect, useState } from 'react';
import { connect } from 'dva';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Card, Row, Table, Tag, Spin } from 'antd';
import moment from 'moment';
import { ACTION_CLIENTS_LOAD_RECOGNITION_USAGES } from '../../../models/clients';

const { Column } = Table;

const RecognitionUsages = (props) => {
  const { clientId, intl, loading } = props;
  const [usages, setUsages] = useState([]);

  useEffect(() => {
    if (!clientId) {
      return;
    }

    props
      .dispatch({ type: ACTION_CLIENTS_LOAD_RECOGNITION_USAGES, payload: { id: clientId } })
      .then((response) => {
        setUsages(Array.isArray(response) ? response : []);
      });
  }, [clientId]);

  const formatPeriod = (usage) => {
    const start = moment(usage.period_start).locale(intl.locale);
    const end = moment(usage.period_end).locale(intl.locale);

    return `${start.format('LL')} - ${end.format('LL')}`;
  };

  const packageTitle = (clientPackageId) => {
    if (!clientPackageId) {
      return '-';
    }

    const clientPackage = props.clientPackages.clientPackagesFullList
      .find(item => +item.id === +clientPackageId);

    return clientPackage ? clientPackage.title : `#${clientPackageId}`;
  };

  const formatNumber = data => (
    data === null || data === undefined ? '-' : intl.formatNumber(data)
  );

  return (
    <Card>
      <Row gutter={16}>
        <h2>
          <FormattedMessage id="Component.Administration.Clients.RecognitionUsages" />
        </h2>
      </Row>
      <Spin spinning={!!loading.effects[ACTION_CLIENTS_LOAD_RECOGNITION_USAGES]}>
        <Table
          dataSource={usages}
          rowKey="period_start"
          pagination={false}
          size="middle"
          locale={{
            emptyText: intl.formatMessage({
              id: 'Component.Administration.Clients.RecognitionUsages.Empty',
            }),
          }}
        >
          <Column
            key="period"
            title={intl.formatMessage({
              id: 'Component.Administration.Clients.RecognitionUsages.Period',
            })}
            render={usage => <div>{formatPeriod(usage)}</div>}
          />
          <Column
            dataIndex="recognitions_count"
            title={intl.formatMessage({
              id: 'Component.Administration.Clients.RecognitionUsages.RecognitionsCount',
            })}
            render={data => <div>{formatNumber(data)}</div>}
          />
          <Column
            dataIndex="client_package_id"
            title={intl.formatMessage({
              id: 'Component.Administration.Clients.Package',
            })}
            render={data => <div>{packageTitle(data)}</div>}
          />
          <Column
            dataIndex="monthly_limit"
            title={intl.formatMessage({
              id: 'Component.Administration.ClientPackages.Form.MonthlyLimit',
            })}
            render={data => <div>{formatNumber(data)}</div>}
          />
          <Column
            dataIndex="remaining"
            title={intl.formatMessage({
              id: 'Component.Administration.Clients.RecognitionUsages.Remaining',
            })}
            render={data => <div>{formatNumber(data)}</div>}
          />
          <Column
            dataIndex="is_limit_reached"
            title={intl.formatMessage({
              id: 'Component.Administration.Clients.RecognitionUsages.IsLimitReached',
            })}
            render={data => (
              <Tag color={data ? 'red' : 'green'}>
                {intl.formatMessage({ id: data ? 'Common.Yes' : 'Common.No' })}
              </Tag>
            )}
          />
        </Table>
      </Spin>
    </Card>
  );
};

export default connect(({ loading, clientPackages }) => ({ loading, clientPackages }))(
  injectIntl(RecognitionUsages),
);



// WEBPACK FOOTER //
// ./src/components/Clients/ClientsItem/RecognitionUsages.js